import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import isConfettiEnabled from '../selectors/isConfettiEnabled';
export default function isConfettiOptionDirty() {
    var userOptions = getOptionsForFeature(OwsOptionsFeatureType.Confetti);
    return isConfettiEnabled() !== userOptions.confettiEnabled;
}
//# sourceMappingURL=isConfettiOptionDirty.js.map